import { urlParams } from "../../../../../../assets/js/src/general/utils";
import { writable } from "svelte/store";
import { columns, defaultVisibilityByKind } from "./columns";

export const callsQueryParamsStore = writable(null);

class CallsQueryParams {
  columns = $state(columns.map((col) => ({ ...col })));

  #order = $state([]);

  get order() {
    return this.#order;
  }

  set order(value) {
    this.reset();
    this.#order = value;
    this.#set();
  }

  #start = $state(0);

  get start() {
    return this.#start;
  }

  set start(value) {
    this.#start = value;
    this.#set();
  }

  #length = $state(10);

  get length() {
    return this.#length;
  }

  set length(value) {
    this.#length = value;
    this.#set();
  }

  #search = $state({ value: "", regex: false });

  set search(value) {
    this.start = 0;
    this.#search = value;
    this.#set();
  }

  get search() {
    return this.#search;
  }

  #candidateIds = $state([]);

  get candidateIds() {
    return this.#candidateIds;
  }

  set candidateIds(value) {
    this.reset();
    this.#candidateIds = value;
    this.#set();
  }

  #campaignIds = $state([]);

  get campaignIds() {
    return this.#campaignIds;
  }

  set campaignIds(value) {
    this.reset();
    this.#campaignIds = value;
    this.#set();
  }

  #userIds = $state([]);

  get userIds() {
    return this.#userIds;
  }

  set userIds(value) {
    this.reset();
    this.#userIds = value;
    this.#set();
  }

  #outcomeIds = $state([]);

  get outcomeIds() {
    return this.#outcomeIds;
  }

  set outcomeIds(value) {
    this.reset();
    this.#outcomeIds = value;
    this.#set();
  }

  #kinds = $state([]);

  get kinds() {
    return this.#kinds;
  }

  set kinds(value) {
    this.reset();
    this.#kinds = value;
    this.#set();
  }

  #connected = $state(false);

  get connected() {
    return this.#connected;
  }

  set connected(value) {
    this.reset();
    this.#connected = value;
    this.#set();
  }

  #recorded = $state(false);

  get recorded() {
    return this.#recorded;
  }

  set recorded(value) {
    this.reset();
    this.#recorded = value;
    this.#set();
  }

  #timestampFrom = $state(null);

  get timestampFrom() {
    return this.#timestampFrom;
  }

  set timestampFrom(value) {
    this.reset();
    this.#timestampFrom = value;
    this.#set();
  }

  #timestampTo = $state(null);

  get timestampTo() {
    return this.#timestampTo;
  }

  set timestampTo(value) {
    this.reset();
    this.#timestampTo = value;
    this.#set();
  }

  #projectIds = $state([]);

  get projectIds() {
    return this.#projectIds;
  }

  set projectIds(value) {
    this.reset();
    this.#projectIds = value;
    this.#set();
  }

  #set() {
    const data = {
      columns: this.columns,
      order: this.order,
      start: this.start,
      length: this.length,
      search: this.search,
      candidateIds: this.candidateIds,
      campaignIds: this.campaignIds,
      userIds: this.userIds,
      outcomeIds: this.outcomeIds,
      kinds: this.kinds,
      connected: this.connected,
      recorded: this.recorded,
      timestampFrom: this.timestampFrom,
      timestampTo: this.timestampTo,
      projectIds: this.projectIds,
    };

    this.store.set(data);
  }

  /**
   * Reset the API store (and pagination offset) - this retriggers the full
   * table skeleton loader and reloads data
   */
  reset(set = false) {
    this.store.set(null); // trigger reset in API store
    if (set) this.#set(); // set back to current state
  }

  setDefaultVisibility(kind) {
    const on = defaultVisibilityByKind[kind] || [];
    this.columns.forEach((col) => {
      col.visible = on.includes(col.name);
    });
  }

  constructor({ store, defaultVisibility, initializeProjectId }) {
    this.store = store;

    const i = this.columns.findIndex((c) => c.name === "timestamp");
    this.order = i > -1 ? [{ column: i, dir: "desc" }] : [];

    this.setDefaultVisibility(defaultVisibility);

    if (initializeProjectId) {
      const projectId = urlParams.get("projectId");
      if (projectId) {
        this.projectIds = [projectId];
      }
    }
  }
}

export const callsQueryParams = new CallsQueryParams({
  store: callsQueryParamsStore,
  defaultVisibility: "contact",
  initializeProjectId: false,
});
